import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../component/message/Msg";
import TableViewer from "../../component/tableViewer/TableViewer";

const ViewExam = () => {
  const token = config.token;
  const { id } = useParams();
  const navigate = useNavigate();

  //------------------------------------------- State management -------------------------------------------
  const [loading, setLoading] = useState(false);
  const [mcqBanks, setMcqBanks] = useState([]);
  const [bankFor, setBankFor] = useState({
    bFor: "chapterid",
    cid: "",
    chapters: [],
    courses: [],
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [courseSearchTerm, setCourseSearchTerm] = useState('');

  const filteredCourses = bankFor.courses.filter((course) =>
    course.course_name.toLowerCase().includes(courseSearchTerm.toLowerCase())
  );

  const handleCourseChangeDropdown = (e) => {
    setBankFor((prevData) => ({
      ...prevData,
      cid: e.target.value,
    }));
    setIsDropdownOpen(false); // Close dropdown after selection
    setCourseSearchTerm('');
  };

  const handleSearchChange = (e) => {
    setCourseSearchTerm(e.target.value);
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  //  ------For TableViewer ------
  const banksRef = useRef([]);
  banksRef.current = mcqBanks;
  const [rowData, setRowData] = useState([]);

  //  ------For TableViewer ------

  const handleCourChangeDropdown = (e) => {
    setBankFor((prevData) => ({
      ...prevData,
      cid: e,
    }));
    setLoading(true);
    //fetch Exam
    fetch(`${config.host_url}exams/${bankFor.bFor == "chapterid" ? 'chapter' : 'course'}/${e}`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setMcqBanks(data.data);

        const examsData = data.data?.map((exam) => ({
          exam_name: exam.exam_name,
          pattern: exam.pattern,
          isFree: exam.isFree,
          set_exam_timer: exam.set_exam_timer,
          exam_timer: exam.exam_timer,
          set_que_timer: exam.set_que_timer,
          que_timer: exam.que_timer,
          set_warning: exam.set_warning,
          warning_seconds: exam.warning_seconds,
          idNumber: exam.mbid,
        }));
        setRowData(examsData);
      });
    setLoading(false);
  };

  //-------------------------------------- fetch data form prameters ----------------------------------------
  useEffect(() => {
    if (id !== undefined) {
      setBankFor((prevData) => ({
        ...prevData,
        cid: decodeURIComponent(atob(id)),
      }));

      setLoading(true);
      //fetch Exam
      fetch(`${config.host_url}exams/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("exam:", data.data);
          setMcqBanks(data.data);
          //  ------For TableViewer ------
          const examsData = data.data?.map((exam) => ({
            exam_name: exam.exam_name,
            pattern: exam.pattern,
            isFree: exam.isFree,
            set_exam_timer: exam.set_exam_timer,
            exam_timer: exam.exam_timer,
            set_que_timer: exam.set_que_timer,
            que_timer: exam.que_timer,
            set_warning: exam.set_warning,
            warning_seconds: exam.warning_seconds,
            idNumber: exam.mbid,
          }));
          setRowData(examsData);
          //  ------For TableViewer ------
        });
      setLoading(false);
    }
  }, [id]);

  //-------------------------------------- get course for dropdown option --------------------------------------r
  useEffect(() => {
    fetch(`${config.host_url}chapter`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setBankFor((prevData) => ({
            ...prevData,
            chapters: data.data,
          }));
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching chapter:", error);
      });
    // Fetch course list
    fetch(`${config.host_url}course`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setBankFor((prevData) => ({
            ...prevData,
            courses: data.data,
          }));
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching course:", error);
      });
  }, [token]);
  const [selectedValue, setSelectedValue] = useState("");
  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const uniqueOptions = bankFor.bFor === "chapterid"
    ? Array.from(new Set(bankFor.chapters.map(chapter => chapter.chapterid)))
      .map(id => bankFor.chapters.find(chapter => chapter.chapterid === id))
    : bankFor.bFor === "courseid"
      ? Array.from(new Set(bankFor.courses.map(course => course.course_id)))
        .map(id => bankFor.courses.find(course => course.course_id === id))
      : [];
  const filteredOptions = uniqueOptions.filter(option =>
    bankFor.bFor === "chapterid"
      ? option.name.toLowerCase().includes(searchTerm.toLowerCase())
      : option.course_name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const handleOptionSelect = (option) => {
    setSelectedValue(option);
    handleCourChangeDropdown(option);
    setIsDropdownOpen(false);
  };
  // const handleChapCourChangeDropdown = (option) => {
  //   setBankFor((prevData) => ({
  //     ...prevData,
  //     cid: option,
  //   }));
  // };
  // ------------------------------------------------------------------ Delete Exam -----------------------------------------------------D
  const handleDeleteBtn = (id, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete Exam. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id, i);
      }
    });
    //Confirm delete
    const handleDelete = (id, i) => {
      fetch(`${config.host_url}exams/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      })
        .then(function (response) {
          // console.log("Response:", response);
          return response.json();
        })
        .then(function (data) {
          // console.log("Data:", data);
          if (data.status === 200) {
            triggerNotification("success", "Exam deleted successfully");

            //  ------For TableViewer ------
            const updatedMCQBank = [...banksRef.current];
            updatedMCQBank.splice(i, 1);
            setMcqBanks(updatedMCQBank);

            const examsData = updatedMCQBank?.map((exam) => ({
              exam_name: exam.exam_name,
              pattern: exam.pattern,
              isFree: exam.isFree,
              set_exam_timer: exam.set_exam_timer,
              exam_timer: exam.exam_timer,
              set_que_timer: exam.set_que_timer,
              que_timer: exam.que_timer,
              set_warning: exam.set_warning,
              warning_seconds: exam.warning_seconds,
              idNumber: exam.mbid,
            }));
            setRowData(examsData);
            //  ------For TableViewer ------
          } else if (data.status === 404) {
            triggerNotification("error", "Exam not found");
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated User");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        })
        .catch(function (error) {
          console.error("Error:", error);
          triggerNotification("error", "Error deleting Exam");
        });
    };
  };

  // ------------------------------------------------------------------ edit Exam -----------------------------------------------------U
  const handleEditBtn = (id) => {
    navigate(`/addexam/${btoa(encodeURIComponent(id))}`);
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "exam_name", filter: true, headerName: "Exam Name" },
    { field: "pattern", filter: true, width: 120 },
    {
      field: "isFree",
      headerName: "Is Free?",
      filter: true,
      width: 150,
      valueFormatter: (params) => {
        return params.data.isFree === 1 ? "Free" : "Not Free";
      },
    },
    {
      field: "set_exam_timer",
      headerName: "Exam Timer (In Minutes)",
      filter: true,
      width: 225,
      valueFormatter: (params) => {
        return params.data.set_exam_timer === 1 ? params.data.exam_timer : "NA";
      },
    },
    {
      field: "set_que_timer",
      headerName: "Question Timer (In Minutes)",
      filter: true,
      width: 230,
      valueFormatter: (params) => {
        return params.data.set_que_timer === 1 ? params.data.que_timer : "NA";
      },
    },
    {
      field: "set_warning",
      headerName: "Warning Timer (In Minutes)",
      filter: true,
      width: 225,
      valueFormatter: (params) => {
        return params.data.set_warning === 1
          ? params.data.warning_seconds
          : "NA";
      },
    },
  ];
  const handleRadioChange = (e) => {
    if (e.target.value === "courseid") {
      setBankFor((prevData) => ({
        ...prevData,
        cid: "",
        bFor: "courseid",
      }));
    } else if (e.target.value === "chapterid") {
      setBankFor((prevData) => ({
        ...prevData,
        cid: "",
        bFor: "chapterid",
      }));
    }
  };
  //  ------For TableViewer ------

  return (
    <>
      <Breadcrumb txt="Manage Exam " subpath={["View Exams"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Exams</h5>
            <div>
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addexam");
                }}
              >
                Add Exam
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3 row mx-4">
              {/* chapter / course   */}
              <div className="col mt-2">
                <div className="form-check form-check-inline ml-1">
                  <input
                    defaultChecked
                    name="form-check-group-image"
                    className="form-check-input"
                    type="radio"
                    value="chapterid"
                    id="chapter"
                    checked={bankFor.bFor === "chapterid"}
                    onChange={handleRadioChange}
                  />
                  <label className="form-check-label" htmlFor="chapter">
                    Chapter
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    name="form-check-group-image"
                    className="form-check-input"
                    type="radio"
                    value="courseid"
                    id="course"
                    checked={bankFor.bFor === "courseid"}
                    onChange={handleRadioChange}
                  />
                  <label className="form-check-label" htmlFor="course">
                    Course
                  </label>
                </div>
              </div>

              {/* chapter / course   */}
              <div className="col-md-12 mt-2 dropdown">
                <div className="form-floating form-floating-outline mb-4">
                  <div className={`form-control w-100 ${selectedValue ? 'text-left' : 'text-center'}`} onClick={toggleDropdown} style={{ cursor: 'pointer' }}>
                    {selectedValue
                      ? bankFor.bFor === "chapterid"
                        ? bankFor.chapters.find(chapter => chapter.chapterid === selectedValue)?.name
                        : bankFor.courses.find(course => course.course_id === selectedValue)?.course_name
                      : bankFor.bFor === "chapterid"
                        ? "---- Select Chapter ----"
                        : bankFor.bFor === "courseid"
                          ? "---- Select Course ----"
                          : "Please first select MCQ Bank For"}
                  </div>

                  {isDropdownOpen && (
                    <div className="dropdown-menu show w-100 p-2" style={{ maxHeight: '162px', overflowY: 'auto' }}>
                      <input
                        type="text"
                        className="form-control mb-2 w-100"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        autoFocus
                      />

                      <div className="dropdown-divider w-100"></div>
                      {filteredOptions.length > 0 ? (
                        filteredOptions.map((option, i) => (
                          <div
                            key={i}
                            className="dropdown-item w-100"
                            onClick={() => handleOptionSelect(bankFor.bFor === "chapterid" ? option.chapterid : option.course_id)}
                          >
                            {bankFor.bFor === "chapterid" ? option.name : option.course_name}
                          </div>
                        ))
                      ) : (
                        <div className="dropdown-item text-muted">No options found</div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* ------For TableViewer ------ */}
              {bankFor.cid !== "" && (
                <TableViewer
                  rowData={rowData}
                  colDefs={colDefs}
                  onEdit={handleEditBtn}
                  onDelete={handleDeleteBtn}
                />
              )}
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewExam;
